import { render, staticRenderFns } from "./CreateSundryItemPopUp.vue?vue&type=template&id=b70ce306&scoped=true&"
import script from "./CreateSundryItemPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateSundryItemPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateSundryItemPopUp.vue?vue&type=style&index=0&id=b70ce306&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70ce306",
  null
  
)

export default component.exports